/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityRegionRequest
 */
export interface CreateFacilityRegionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityRegionRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFacilityRegionRequest
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the CreateFacilityRegionRequest interface.
 */
export function instanceOfCreateFacilityRegionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "facility_ids" in value;

    return isInstance;
}

export function CreateFacilityRegionRequestFromJSON(json: any): CreateFacilityRegionRequest {
    return CreateFacilityRegionRequestFromJSONTyped(json, false);
}

export function CreateFacilityRegionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityRegionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function CreateFacilityRegionRequestToJSON(value?: CreateFacilityRegionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'facility_ids': value.facility_ids,
    };
}

